import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mapBox: {
      [theme.breakpoints.between('sm', 'md')]: {
        height: 500,
      },
      [theme.breakpoints.between('md', 'lg')]: {
        height: 550,
      },
      [theme.breakpoints.up('xl')]: {
        height: 700,
      },
    },
    controlBarBox: {
      height: 40,
      background: `${theme.palette.secondary.main}`,
      borderRadius: '0px 0px 10px 10px',
    },
    controlButton: {
      color: '#fff',
    },
    leafletMap: {
      height: '100%',
      width: '100%',
      borderRadius: '10px 10px 0px 0px',
    },
    autoZoom: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginRight: '10px',
      zIndex: 10,
    },
    slider: {
      '& .MuiSlider-root': {
        color: theme.palette.secondary.main,
        height: 8,
      },
      '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: `2px solid ${theme.palette.secondary.main}`,
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
          boxShadow: 'inherit',
        },
      },
      '& .MuiSlider-active': {},
      '& .MuiSlider-valueLabel': {
        left: 'calc(-50% + 4px)',
      },
      '& .MuiSlider-track': {
        height: 8,
        borderRadius: 4,
      },
      '& .MuiSlider-rail': {
        height: 8,
        borderRadius: 4,
        color: theme.palette.secondary.main,
      },
    },
    toggleBtn: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      minWidth: 100,
      background: `${theme.palette.secondary.main}`,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: 15,
      marginBottom: theme.spacing(1),
      textTransform: 'none',
      color: theme.palette.colors.white,
    },
    title: {
      fontSize: 13,
    },
    icon: {
      '& path': {
        fill: theme.palette.colors.white,
      },
    },
    toggleBtnNoActive: {
      background: theme.palette.colors.gray6,
      color: theme.palette.colors.gray3,
      '& svg > path': {
        fill: theme.palette.colors.gray3,
      },
    },
    satelliteIcon: {
      color: 'inherit',
    },
  }),
);

export default useStyles;
